import { CONTRACT } from '@/store/types';
import store from '@/store';
import useAuth from '@/auth';

const auth = useAuth();

function checkContract({ to, next }) {
  // redirect any route if contract not passed
  if (to.name !== 'contract') {
    const contractState = store.getters[CONTRACT];
    const validTargets = ['login', 'logout', 'register-steps'];
    const isSudoer = auth.user?.isSudoFromAdmin;

    if (
      contractState !== 'NOT-ACCEPTED-PASSED-DUE-DATE' ||
      validTargets.includes(to.name) ||
      isSudoer
    ) {
      next();
    } else {
      next({
        name: 'contract',
      });
    }
  } else {
    next();
  }
}

export default function(to, from, next) {
  if (auth.ready) {
    return checkContract({ to, next });
  }

  auth.onReady(() => checkContract({ to, next }));
}
